export default __webpack_public_path__ + "static/media/bloxified.2097ce74.gif";